import { trpc } from "@blis/trpc/react";

import { PanelsTable } from "../components/panels/PanelsTable";
import { Section } from "../components/Section";

export function PanelsPage() {
  const { data } = trpc.admin.panel.list.useQuery();

  return (
    <>
      <Section.Title>Panels</Section.Title>
      <PanelsTable panels={data} />
    </>
  );
}
